import React, { FC } from "react";

import { useFieldArray, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { AddButton } from "@/components/atoms";

import { CompanyFormType } from "../../../../formType";
import { companyPhoneDefaultValues } from "../../formType";
import PhoneForm from "../PhoneForm/PhoneForm";

const MAX_PHONES_NUMBER = 3;

const PhonesGroup: FC = () => {
    const { t } = useTranslation();

    const { control } = useFormContext<CompanyFormType>();

    const {
        fields: phones,
        append,
        remove,
    } = useFieldArray({
        control,
        name: "contact.telephoneNumbers",
    });

    const removePhone = (index) => {
        remove(index);
    };

    const addPhone = () => {
        append(companyPhoneDefaultValues());
    };

    return (
        <>
            {phones.map((phone, index) => (
                <PhoneForm index={index} key={phone.id} removePhone={() => removePhone(index)} />
            ))}
            <AddButton
                onClick={addPhone}
                label={t("Common.OneMorePhone")}
                style={{ marginBottom: "15px", marginTop: "8px" }}
                disabled={phones.length >= MAX_PHONES_NUMBER}
            />
        </>
    );
};

export default PhonesGroup;
